import React, { useState, useRef } from 'react';

import { Grid, Paper, Typography, Divider } from '@material-ui/core';

import { ButtonGeneric, IconButtonGeneric } from '../atoms/Buttons';
import { GenericModal } from '../organisms/GenericModal';
import { useFormNew } from '../../../hooks/useFormNew';
import { GenericForm } from '../organisms/GenericForm';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { Search } from '@material-ui/icons';

const initModal = {
  open: false,
  value: '',
};

export const TemplateABM = ({
  data,
  formStructure,
  dataTable,
  submit,
  deleteButton,
  tableProps = {},
  titles,
  without,
}) => {
  const componentRef = useRef();

  const [modal, setModal] = useState(initModal);
  const [deleteModal, setDeleteModal] = useState(initModal);

  const handleDelete = (e) => {
    e.preventDefault();
    deleteButton(deleteModal.value.id || deleteModal.value, () => setDeleteModal(initModal));
  };

  return (
    <Grid container spacing={1} justify="center">
      {!without?.insert && (
        <Grid
          item
          xs={11}
          style={{
            padding: '1.5em',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <ButtonGeneric
            type="button"
            text={`+ ${titles.insert}`}
            onClick={() => {
              setModal({
                open: true,
                value: data(),
              });
            }}
          />
        </Grid>
      )}
      <Grid
        item
        xs={11}
        style={{ margin: '1em', padding: '1em 0', overflow: 'hidden' }}
        component={Paper}
        elevation={2}
      >
        <Grid container spacing={1} direction="column" justify="center">
          {!without?.title && (
            <>
              <Grid
                item
                xs={12}
                style={{ textAlign: 'center', margin: '0.8em 0' }}
              >
                <Typography variant="button" style={{ fontSize: '1.5em' }}>
                  {titles.abm}
                </Typography>
              </Grid>
              <Grid item xs={12} component={Divider} />
            </>
          )}
          <Grid item xs={12}>
            <TableGeneric
              {...tableProps}
              ref={componentRef}
              data={dataTable.list}
              align="center"
              columns={[
                ...(!without?.delete
                  ? [
                      {
                        id: '',
                        label: '',
                        customBody: (item) => (
                          <IconButtonGeneric
                            onClick={() => {
                              setDeleteModal({
                                open: true,
                                value: item,
                              });
                            }}
                          />
                        ),
                      },
                    ]
                  : []),
                ...dataTable.columns,
                ...(!without?.update
                  ? [
                      {
                        id: '',
                        label: '',
                        customBody: (item) => (
                          <IconButtonGeneric
                            ariaLabel="update"
                            Icon={Search}
                            color="primary"
                            onClick={() => {
                              setModal({
                                open: true,
                                value: data(item),
                              });
                            }}
                          />
                        ),
                      },
                    ]
                  : []),
              ]}
            />
          </Grid>
        </Grid>
      </Grid>

      {modal.open && (
        <Form
          open={modal.open}
          handleClose={() => {
            setModal(initModal);
          }}
          title={modal.value.id ? titles.update : titles.insert}
          submit={submit}
          data={modal.value}
          formStructure={formStructure}
        />
      )}

      {deleteModal.open && (
        <GenericModal
          open={deleteModal.open}
          handleClose={() => {
            setDeleteModal(initModal);
          }}
          title={titles.delete}
          textButton="Eliminar"
          handleSubmit={handleDelete}
          gridStyle={{ textAlign: 'center' }}
        >
          <Typography variant="button" style={{ fontSize: '1.1em' }}>
            {`Desea eliminar ${deleteModal.value.descripcion || "este registro"}?`}
          </Typography>
        </GenericModal>
      )}
    </Grid>
  );
};

const Form = ({ data, formStructure, submit, ...props }) => {
  const form = useFormNew(data);

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(form.formValues, props.handleClose);
  };

  return (
    <GenericModal handleSubmit={handleSubmit} {...props}>
      <GenericForm form={formStructure(form)} />
    </GenericModal>
  );
};
